import { API_URL } from "../config/config";
import { getRequest, postRequest } from "../utils/axiosUtils";

export const fetchRecruiterList = async (setRecruiterList, setLoadingRecruiters) => {
  if (setLoadingRecruiters) setLoadingRecruiters(true);
  try {
    const response = await getRequest({
      url: `${API_URL}/recruiter`,
    });
    const recruiters = response?.data?.recruiters;
    if (!response?.data?.success || !Array.isArray(recruiters)) {
      const error = new Error(response?.data?.message || "Recruiters not found");
      error.fieldErrors = response?.data?.errors || {};
      throw error;
    }
    const mappedRecruiters = recruiters.map(item => ({
      label: item.name,
      value: item._id,
      image: item.image || "",
    }));
    if (setRecruiterList) setRecruiterList(mappedRecruiters);
    return mappedRecruiters;

  } catch (err) {
    if (setRecruiterList) setRecruiterList([]);
    const responseData = err?.response?.data;
    if (responseData) {
      const customError = new Error(responseData.message || "Failed to fetch recruiters");
      customError.fieldErrors = responseData.errors || {};
      throw customError;
    }
    throw new Error(err.message || "Unknown error occurred while fetching recruiters");
  } finally {
    if (setLoadingRecruiters) setLoadingRecruiters(false);
  }
};

export const addRecruiter = async ({ name, image }, setLoadingAddRecruiter) => {
  if (setLoadingAddRecruiter) setLoadingAddRecruiter(true);
  try {
    const response = await postRequest({
      url: `${API_URL}/recruiter`,
      data: { name, image },
    });
    const recruiter = response?.data?.recruiter;
    if (!response?.data?.success || !recruiter) {
      const error = new Error(response?.data?.message || "Failed to add recruiter");
      error.fieldErrors = response?.data?.errors || {};
      throw error;
    }
    return {
      label: recruiter.name,
      value: recruiter._id,
      image: recruiter.image || "",
    };
  } catch (err) {
    const responseData = err?.response?.data;
    if (responseData) {
      const customError = new Error(responseData.message || "Failed to add recruiter");
      customError.fieldErrors = responseData.errors || {};
      throw customError;
    }
    throw new Error(err.message || "Unknown error occurred while adding recruiter");
  } finally {
    if (setLoadingAddRecruiter) setLoadingAddRecruiter(false);
  }
};
